.scroller {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  font-size: var(--text-sm);
}

.table thead th {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  background: var(--bg-surface);
  padding: var(--space-3) var(--space-4);
  text-align: left;
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
  color: var(--text-tertiary);
  white-space: nowrap;
  border-bottom: 1px solid var(--border-default);
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.sortable:hover {
  color: var(--text-primary);
}

.headInner {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.sortIcon {
  opacity: 0.35;
}

.sortActive {
  opacity: 1;
  color: var(--accent);
}

.table tbody td {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
  vertical-align: middle;
  color: var(--text-secondary);
}

.row {
  transition: background var(--duration-fast) var(--ease-out);
}

.clickable {
  cursor: pointer;
}

.clickable:hover td {
  background: var(--bg-hover);
}

.clickable:focus-visible {
  outline: none;
}

.clickable:focus-visible td {
  background: var(--bg-hover);
  box-shadow: inset 0 0 0 1px var(--accent);
}

.numeric {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.alignRight {
  text-align: right;
}
